<template>
  <div class="hot-question">
    <div class="title">
      <span class="txt">热门提问</span>
      <HeadEdit icon="icon-tiwen" txt="萌新提问" @click="() => $emit('question')" />
    </div>
    <HotQuestionItem v-for="(item, index) in list" :key="item.id" :item="item" :seq="index + 1" />
  </div>
</template>
<script>
import { apiContentTopList } from "@/api/contentApi";

import HeadEdit from "./HeadEdit.vue";
import HotQuestionItem from "./HotQuestionItem.vue";

export default {
  name: "HotQuestion",
  components: { HeadEdit, HotQuestionItem },
  data() {
    return {
      list: []
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onQuestion() {
      //
    },
    async fetchList() {
      const params = {
        limit: 5,
        page_no: 1,
        page_total: 1,
        total: 0,
        type: 17,
        order_by: "hot"
      };

      const { code, data } = await apiContentTopList(params);
      if (code === 0) {
        this.list = data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.hot-question {
  border-radius: 8px;
  background-color: var(--zs-qz-card-bg);
  padding-bottom: 2px;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 10px 24px;
    border-bottom: 1px solid var(--zs-qz-tabs-border-color);
    .txt {
      color: var(--zs-qz-hot-question-title-color);
      font-size: 20px;
    }
  }
}
</style>
